<div div class="relative container mx-auto my-8 flex flex-col">
  <ng-container *ngIf="images$ | async; let images">
    <div *ngIf="images.length === 0" class="mb-4 flex items-center gap-2">
      <input 
        type="checkbox" 
        id="notApplicablePhoto"
        [(ngModel)]="notApplicable"
        (change)="onNotApplicableChange()"
        class="h-4 w-4 rounded border-zinc-300 text-cam-blue focus:ring-cam-blue"
      />
      <label for="notApplicablePhoto" class="text-zinc-900 dark:text-zinc-200">
        Not Applicable - I do not have any photos to upload
      </label>
    </div>
  </ng-container>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-4">
    <div class="overflow-x-auto">
      <table class="table-auto border-separate border border-zinc-600">
        <thead class="bg-zinc-300 dark:bg-zinc-700">
          <tr>
            <th
              *ngFor="let head of headers"
              scope="col"
              class="border border-zinc-600 px-2 py-1 dark:border-white/10"
            >
              {{ head }}
            </th>
          </tr>
        </thead>
        <ng-container *ngIf="images$ | async; let images">
          <tbody *ngIf="images.length > 0; else noItems">
            <tr
              *ngFor="
                let image of images
                  | paginate: { itemsPerPage: 10, currentPage: p }
              "
            >
              <td width="40%">
                <div class="flex w-full justify-center">
                  <img
                    src="{{ image.URI }}"
                    [alt]="image.Title"
                    class="h-20 w-20"
                  />
                </div>
              </td>
              <td
                width="40%"
                *ngIf="
                  !editState ||
                  (editState && itemToEdit.ImageID !== image.ImageID)
                "
              >
                {{ image.Title }}
              </td>
              <td
                width="40%"
                *ngIf="editState && itemToEdit.ImageID == image.ImageID"
              >
                <input
                  *ngIf="!submitted || form.get('Title')?.valid"
                  formControlName="Title"
                  class="self-start rounded-lg border px-1 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                />
                <div
                  *ngIf="submitted && !form.get('Title')?.valid"
                  data-tip="Enter a valid title"
                >
                  <input
                    formControlName="Title"
                    type="text"
                    class="self-start rounded-lg border px-1 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  />
                </div>
              </td>
              <td
                *ngIf="
                  !editState ||
                  (editState && itemToEdit.ImageID !== image.ImageID)
                "
              >
                {{ image.IsSafe ? "Yes" : "No" }}
              </td>
              <td *ngIf="editState && itemToEdit.ImageID == image.ImageID">
                <div class="flex justify-center">
                  <div class="flex flex-col items-start">
                    <div>
                      <input
                        type="radio"
                        name="IsSafe"
                        id="exampleRadios1"
                        [value]="true"
                        formControlName="IsSafe"
                      />
                      <label for="exampleRadios1"> Yes </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        [value]="false"
                        formControlName="IsSafe"
                        name="IsSafe"
                        id="exampleRadios2"
                      />
                      <label for="exampleRadios2"> No </label>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="submitted && !form.get('IsSafe')?.valid"
                  data-tip="Enter a valid title"
                >
                  <input
                    formControlName="IsSafe"
                    type="text"
                    class="self-start rounded-lg border px-1 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  />
                </div>
              </td>
              <td>
                <div class="flex flex-col gap-1 px-2 text-sm">
                  <button
                    *ngIf="
                      !editState ||
                      (editState && itemToEdit.ImageID !== image.ImageID)
                    "
                    type="button"
                    class="rounded bg-blue-500 px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    (click)="onEdit(image)"
                  >
                    Edit
                  </button>
                  <button
                    *ngIf="editState && itemToEdit.ImageID == image.ImageID"
                    class="rounded bg-cam-green px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    type="submit"
                  >
                    Save
                  </button>
                  <button
                    *ngIf="
                      !editState ||
                      (editState && itemToEdit.ImageID !== image.ImageID)
                    "
                    type="button"
                    class="rounded bg-cam-red px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    (click)="onDelete(image)"
                  >
                    Delete
                  </button>
                  <button
                    *ngIf="editState && itemToEdit.ImageID == image.ImageID"
                    class="rounded bg-zinc-400 px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    type="button"
                    (click)="onCancel()"
                  >
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </form>
  <div class="flex justify-center">
    <pagination-controls (pageChange)="p = $event"></pagination-controls>
  </div>
  <div class="flex justify-center">
    <ng-container *ngIf="buttonState$ | async; let state">
      <button
        [class]="(state.images.length > 0 || notApplicable) && !state.isUploading && !isNavigating
          ? 'flex cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-green-100 outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none'
          : 'cursor-not-allowed justify-center rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'"
        [disabled]="!(state.images.length > 0 || notApplicable) || state.isUploading || isNavigating"
        type="button"
        (click)="onSurveySubmit()"
      >
        <span *ngIf="state.isUploading">Uploading...</span>
        <span *ngIf="!state.isUploading && isNavigating">Saving...</span>
        <span *ngIf="!state.isUploading && !isNavigating">Save and Continue</span>
      </button>
    </ng-container>
  </div>
</div>
<ng-template #noItems>
  <td colspan="8" class="text-center">
    <h5>There is no data to display!!</h5>
  </td>
</ng-template>
